import { render } from "./ContactView.vue?vue&type=template&id=5abb1cfc&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=5abb1cfc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abb1cfc"]])

export default __exports__